import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import { fmtMoney, fmtNumber } from './adminFormat';

/**
 * Paid invoices per month and currency (last 12 months), from the stored Stripe
 * `invoice.paid` events.
 */
const RevenueTable = ({ monthly }) => {
    if (!monthly || monthly.length === 0) {
        return <Typography color="textSecondary">No paid invoices in the last 12 months.</Typography>;
    }
    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Month</TableCell>
                    <TableCell>Currency</TableCell>
                    <TableCell align="right">Invoices</TableCell>
                    <TableCell align="right">Amount</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {monthly.map((row) => (
                    <TableRow key={`${row.month}-${row.currency}`}>
                        <TableCell>{row.month}</TableCell>
                        <TableCell>{(row.currency || '').toUpperCase()}</TableCell>
                        <TableCell align="right">{fmtNumber(row.invoices)}</TableCell>
                        <TableCell align="right">{fmtMoney(row.amount, row.currency)}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default RevenueTable;
